/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".importContainer[_ngcontent-%COMP%]{padding:20px;text-align:center;overflow-y:auto}.rankingSet[_ngcontent-%COMP%]{width:100%;border-bottom:1px solid #ccc;padding:5px;margin-bottom:5px}.submit[_ngcontent-%COMP%]{background-color:#23be23;color:var(--bkg-color)}.left[_ngcontent-%COMP%]{width:65%;display:inline-block;margin-right:5%}.right[_ngcontent-%COMP%]{width:25%;display:inline-block}.error[_ngcontent-%COMP%]{text-align:center;color:#dc0f0f}"];
export { styles as styles };
